var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_ok",
    transform: "translate(0 -0.219)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 38,
    height: 38,
    transform: "translate(0 0.219)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8295",
    "data-name": "Group 8295",
    transform: "translate(1.662 1.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20016",
    "data-name": "Path 20016",
    d: "M231.73,187.768a1.549,1.549,0,0,0,1.055.383,1.519,1.519,0,0,0,1.055-.427l10.609-10.956a.917.917,0,0,0,.182-1.086,1.373,1.373,0,0,0-1.092-.668,1.565,1.565,0,0,0-1.275.418l-9.568,9.86-4.908-4.585a1.449,1.449,0,0,0-.962-.487,1.634,1.634,0,0,0-1.095.255.957.957,0,0,0-.011,1.651Z",
    transform: "translate(-217.724 -164.239)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20017",
    "data-name": "Path 20017",
    d: "M122.34,69.68A17.338,17.338,0,1,0,110.08,64.6,17.339,17.339,0,0,0,122.34,69.68Zm0-32.2a14.861,14.861,0,1,1-10.508,4.353,14.861,14.861,0,0,1,10.508-4.353Z",
    transform: "translate(-105.002 -35.004)",
    fill: "#0595f0",
    stroke: "#0595f0",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOk);
export default __webpack_public_path__ + "static/media/ico_ok.b4a76ad26e05c44a4264c1de802b6e17.svg";
export { ForwardRef as ReactComponent };